export const logo = require('./logo.svg').default

export const menuAddIcon = require('./add.svg').default
export const menuSettingsIcon = require('./settings.svg').default
export const menuSearchIcon = require('./search.svg').default
export const menuCloseIcon = require('./closeMenu.svg').default

export const imgNotAvailable = require('./img-not-available.jpg')
export const BookIconRead = require('./icon-read.png')
export const BookIconUnread = require('./icon-unread.png')